import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'arrivalRangePipe'
})

export class ArrivalRangePipe implements PipeTransform {
  transform(dateString: string): string {
    if (!dateString) return 'Derzeit keine Information verfügbar';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return 'Derzeit keine Information verfügbar';
    }

    const before = new Date(date.getTime() - 5 * 60 * 1000);
    const after = new Date(date.getTime() + 10 * 60 * 1000);

    const formatTime = (d: Date): string => {
      const hours = d.getHours().toString().padStart(2, '0');
      const minutes = d.getMinutes().toString().padStart(2, '0');
      return `${hours}:${minutes}`;
    };

    return `${formatTime(before)} - ${formatTime(after)}`;
  }
}
